"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const precisionMath_1 = require("./precisionMath");
const round_1 = __importDefault(require("./round"));
function calculateSurchargeModifier(order, surchargeModifier) {
    if (surchargeModifier == null) {
        return;
    }
    let surchargeableTotalAcc = 0;
    let taxableSurchargeableTotalAcc = 0;
    lodash_1.default.forEach(order.batches, batch => {
        batch.items.forEach(item => {
            var _a, _b;
            if (surchargeModifier.overrideItem || !item.excludedOrderSurcharge) {
                const totalForSurcharge = order.isSurchargeBasedOnDiscountedItemTotal === true
                    ? ((_a = item.totalBeforeTax) !== null && _a !== void 0 ? _a : 0)
                    : ((_b = item.totalBeforeTaxWithoutDiscount) !== null && _b !== void 0 ? _b : 0);
                surchargeableTotalAcc = (0, precisionMath_1.add)(surchargeableTotalAcc, totalForSurcharge);
                // Track taxable portion separately
                if (item.isTaxable === true) {
                    taxableSurchargeableTotalAcc = (0, precisionMath_1.add)(taxableSurchargeableTotalAcc, totalForSurcharge);
                }
            }
            item.setItems.forEach(setItem => {
                var _a, _b;
                if (surchargeModifier.overrideItem || !setItem.excludedOrderSurcharge) {
                    const totalForSurcharge = order.isSurchargeBasedOnDiscountedItemTotal === true
                        ? ((_a = setItem.totalBeforeTax) !== null && _a !== void 0 ? _a : 0)
                        : ((_b = setItem.totalBeforeTaxWithoutDiscount) !== null && _b !== void 0 ? _b : 0);
                    surchargeableTotalAcc = (0, precisionMath_1.add)(surchargeableTotalAcc, totalForSurcharge);
                    // Track taxable portion separately
                    if (setItem.isTaxable === true) {
                        taxableSurchargeableTotalAcc = (0, precisionMath_1.add)(taxableSurchargeableTotalAcc, totalForSurcharge);
                    }
                }
            });
        });
    });
    let calculatedAmountAcc = 0;
    const calculateItemSurcharge = (item) => {
        var _a, _b;
        item.surcharge = 0;
        if (surchargeModifier.overrideItem || !item.excludedOrderSurcharge) {
            const totalForSurcharge = order.isSurchargeBasedOnDiscountedItemTotal === true
                ? ((_a = item.totalBeforeTax) !== null && _a !== void 0 ? _a : 0)
                : ((_b = item.totalBeforeTaxWithoutDiscount) !== null && _b !== void 0 ? _b : 0);
            if (surchargeModifier.percent !== 0) {
                // 百分比服務費，直接計算
                const percentageSurcharge = (0, precisionMath_1.multiply)(totalForSurcharge, surchargeModifier.percent / 100);
                item.surcharge = (0, precisionMath_1.add)(item.surcharge, percentageSurcharge);
            }
            if (surchargeModifier.amount !== 0 && surchargeableTotalAcc > 0) {
                // 固定數值的服務費，需要依比例分攤到各個 item
                const distributedAmount = (0, precisionMath_1.multiply)(surchargeModifier.amount, (0, precisionMath_1.divide)(totalForSurcharge, surchargeableTotalAcc));
                item.surcharge = (0, precisionMath_1.add)(item.surcharge, distributedAmount);
            }
        }
        calculatedAmountAcc = (0, precisionMath_1.add)(calculatedAmountAcc, item.surcharge);
    };
    lodash_1.default.forEach(order.batches, batch => {
        batch.items.forEach(item => {
            calculateItemSurcharge(item);
            item.setItems.forEach(setItem => {
                calculateItemSurcharge(setItem);
            });
        });
    });
    // 服務費不可 < 0
    calculatedAmountAcc = Math.max(0, calculatedAmountAcc);
    let nonTaxableSurcharge = 0;
    // 計算服務費稅金
    if (order.surchargeTax == null) {
        nonTaxableSurcharge = calculatedAmountAcc;
    }
    else {
        // Calculate the taxable portion of the surcharge
        const taxableRatio = surchargeableTotalAcc > 0 ? (0, precisionMath_1.divide)(taxableSurchargeableTotalAcc, surchargeableTotalAcc) : 0;
        const nonTaxableRatio = (0, precisionMath_1.subtract)(1, taxableRatio);
        const taxableSurchargeAmount = (0, precisionMath_1.multiply)(calculatedAmountAcc, taxableRatio);
        if (order.surchargeTax.isTaxInclusive) {
            // 服務費內含稅 - only tax the taxable portion
            const taxRate = order.surchargeTax.percent / 100;
            order.surchargeTax.tax = (0, precisionMath_1.multiply)(taxableSurchargeAmount, taxRate);
            order.surchargeTax.taxableTotal = taxableSurchargeAmount;
            nonTaxableSurcharge = (0, precisionMath_1.multiply)(nonTaxableRatio, calculatedAmountAcc);
            // tax inclusive情況下 服務費顯示為稅後服務費
            calculatedAmountAcc = (0, precisionMath_1.add)((0, precisionMath_1.add)(order.surchargeTax.tax, order.surchargeTax.taxableTotal), nonTaxableSurcharge);
            // Total surcharge amount remains the same, but we adjust the tax calculation
        }
        else {
            // 服務費外加稅 - only tax the taxable portion
            order.surchargeTax.tax = (0, precisionMath_1.multiply)(taxableSurchargeAmount, order.surchargeTax.percent / 100);
            order.surchargeTax.taxableTotal = taxableSurchargeAmount;
            nonTaxableSurcharge = (0, precisionMath_1.multiply)(nonTaxableRatio, calculatedAmountAcc);
            // In tax exclusive situation, surcharge display amount excludes tax
            calculatedAmountAcc = (0, precisionMath_1.add)(order.surchargeTax.taxableTotal, nonTaxableSurcharge);
        }
    }
    if (order.enableIntermediateRounding) {
        calculatedAmountAcc = (0, round_1.default)(calculatedAmountAcc, order.rounding.type, order.rounding.digits);
        nonTaxableSurcharge = (0, round_1.default)(nonTaxableSurcharge, order.rounding.type, order.rounding.digits);
        if (order.surchargeTax) {
            order.surchargeTax.tax = (0, round_1.default)(order.surchargeTax.tax, order.rounding.type, order.rounding.digits);
            order.surchargeTax.taxableTotal = (0, round_1.default)(order.surchargeTax.taxableTotal, order.rounding.type, order.rounding.digits);
        }
    }
    return {
        nonTaxableSurcharge,
        modifier: Object.assign(Object.assign({}, surchargeModifier), { calculatedAmount: calculatedAmountAcc }),
    };
}
exports.default = calculateSurchargeModifier;
//# sourceMappingURL=calculateOrderSurcharge.js.map